var render = function render(){var _vm=this,_c=_vm._self._c;return _c('state-container',{attrs:{"actions":_vm.actions,"status":"merged"}},[_c('mr-widget-author-time',{attrs:{"action-text":_vm.s__('mrWidget|Merged by'),"author":_vm.mr.metrics.mergedBy,"date-title":_vm.mr.metrics.mergedAt,"date-readable":_vm.mr.metrics.readableMergedAt}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }